<template>
  <v-layout row wrap my-3>
    <v-flex xs12>
      <v-card>
        <v-toolbar flat dense color="primary" dark>
          <v-toolbar-title>{{ $t('models.control-panel') }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark :loading="loading" @click="fetchData">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar card dense color="white">
          <v-text-field
            v-model="filters.match"
            flat
            hide-details
            :placeholder="$t('action.buttons.search')"
            prepend-icon="search"
            solo
          />
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-data-table
            :value="selected"
            :headers="headers"
            :items="items"
            :rows-per-page-items="[10, 25, 50]"
            :loading="loading"
            disable-initial-sort
            select-all
            :total-items="pagination.totalItems"
            :pagination.sync="pagination"
            item-key="id"
            @input="(v) => $emit('update:selected', v)"
          >
            <template slot="items" slot-scope="props">
              <tr :active="props.selected">
                <td @click="props.selected = !props.selected">
                  <v-checkbox
                    :input-value="props.selected"
                    color="primary"
                    hide-details
                  />
                </td>
                <td class="px-0">
                  <v-layout
                    justify-center
                    align-content-center
                    class="text-xs-center"
                  >
                    <!-- <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          flat
                          icon
                          dark
                          small
                          color="primary"
                          class="mx-0"
                          v-on="on"
                        >
                          <v-icon color="success">edit</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          @click="
                            updateMatch(props.item.id, { reviewed: true })
                          "
                        >
                          <v-list-tile-title>Reviewed</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu> -->
                    <v-menu offset-y>
                      <template #activator="{ on }">
                        <v-btn
                          flat
                          icon
                          dark
                          small
                          color="primary"
                          class="mx-0"
                          v-on="on"
                        >
                          <v-icon color="primary"> visibility </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile @click="openApp(props.item.id)">
                          <v-list-tile-title>Web</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="openAdmin(props.item.id)">
                          <v-list-tile-title>Admin</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-layout>
                </td>

                <td class="text-xs-center" style="min-width: 130px">
                  {{ props.item.date | formatDate }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.time }}
                </td>

                <td>
                  <v-list-tile
                    v-if="props.item.homeTeamId"
                    avatar
                    ripple
                    class="py-2 item"
                  >
                    <v-list-tile-avatar v-if="props.item.homeTeamId.logo">
                      <v-avatar size="32">
                        <img :src="props.item.homeTeamId.logo" alt />
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        <span>
                          {{ props.item.homeTeamId.name }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.homeTeamId.categories"
                        class="caption primary--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.homeTeamId.categories.join(' - ') }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <span v-else>-</span>
                </td>
                <td>
                  <v-list-tile
                    v-if="props.item.visitorTeamId"
                    avatar
                    ripple
                    class="py-2 item"
                  >
                    <v-list-tile-avatar v-if="props.item.visitorTeamId.logo">
                      <v-avatar size="32">
                        <img :src="props.item.visitorTeamId.logo" alt />
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        <span>
                          {{ props.item.visitorTeamId.name }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.visitorTeamId.categories"
                        class="caption primary--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.visitorTeamId.categories.join(' - ') }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <span v-else>-</span>
                </td>
                <td>
                  <v-list-tile
                    v-if="props.item.location"
                    avatar
                    ripple
                    class="py-2 item"
                  >
                    <v-list-tile-avatar v-if="props.item.location.photo">
                      <v-avatar size="24">
                        <img :src="props.item.location.photo" alt />
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        <span>
                          {{ props.item.location.name }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.location.stadiumId"
                        class="caption primary--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.location.stadiumId.name }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn color="primary" flat icon dark small>
                        <v-icon color="primary" class="mr-1"> videocam </v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <span v-else>--</span>
                </td>
                <td class="text-xs-center">
                  <button-recovery-status
                    v-if="
                      props.item.recoveryStatus && !props.item.videoRecovery
                    "
                    :status="props.item.recoveryStatus"
                  />
                  <button-recovery-status
                    v-else-if="props.item.videoRecovery"
                    :status="props.item.videoRecovery.status"
                    :progress="props.item.videoRecovery.progress"
                    :error="props.item.videoRecovery.error"
                  />
                  <span v-else>--</span>
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.active" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.started" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.ended" />
                </td>
                <td class="text-xs-center">
                  <v-progress-circular
                    v-if="loadingViewers"
                    indeterminate
                    size="24"
                    width="3"
                    color="primary"
                  />
                  <span
                    v-else-if="props.item.viewers != undefined"
                    class="title"
                    :class="
                      props.item.viewers == 0 ? 'error--text' : 'primary--text'
                    "
                  >
                    {{ props.item.viewers }}
                  </span>
                  <span v-else>--</span>
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.emissionStatus" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.publicSale" />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { debounce } from 'debounce'
import vuetifyToast from 'vuetify-toast'
import EventBus from '@/EventBus'
import ButtonRecoveryStatus from '@/components/widgets/button/ButtonRecoveryStatus.vue'
import { apiAxios, apiAntmedia } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'ControlPanelList',
  components: { ButtonRecoveryStatus },
  filters: {
    formatDate: function (value) {
      return value ? formatDate(value) : '-'
    },
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      items: [],
      filters: { isCustomer: true, active: 'all' },
      pagination: {
        hasMore: false,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      loading: false,
      loadingViewers: false,
    }
  },
  created() {
    this.fetchData()
    EventBus.$on('fetch-control-panel', this.fetchData)
  },
  beforeDestroy() {
    EventBus.$off('fetch-control-panel')
  },
  watch: {
    filters: {
      handler: debounce(function () {
        this.fetchData()
      }, 500),

      deep: true,
      immediate: true,
    },
    'pagination.page': {
      handler: debounce(function () {
        this.fetchData()
      }, 500),
    },
    'pagination.rowsPerPage': {
      handler: debounce(function () {
        this.fetchData()
      }, 500),
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },

        {
          text: this.$t('fields.global.date'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.time'),
          align: 'center',
          sortable: false,
        },

        {
          text: this.$t('fields.matches.homeTeam'),
          sortable: false,
        },
        {
          text: this.$t('fields.matches.visitorTeam'),
          sortable: false,
        },
        {
          text: this.$t('fields.global.location'),
          sortable: false,
        },
        {
          text: this.$t('titles.matches.recovery'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.matches.started'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.finalized'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.global.viewers'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.emissionStatus'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.publicSale'),
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  methods: {
    async fetchData() {
      try {
        const query = {
          page: this.pagination.page,
          limit: this.pagination.rowsPerPage,
        }

        this.loading = true

        const { data } = await apiAxios.post(
          'matches/control-panel',
          this.filters,
          {
            params: query,
          }
        )
        this.items = data.items
        this.pagination.totalItems = data.paginate.totalData
        this.pagination.page = data.paginate.actualPage
        this.fetchViewers()
      } finally {
        this.loading = false
      }
    },
    async updateMatch(matchId, payload) {
      await apiAxios.put(`matches/${matchId}`, payload)

      vuetifyToast.show({
        text: this.$t('titles.global.action.success'),
        color: 'success',
        timeout: 2000,
        icon: 'check',
      })
      this.fetchData()
    },
    async fetchViewers() {
      try {
        const fetchItemViewers = async (item) => {
          if (
            item.broadcastId &&
            item.streamingStarted &&
            !item.streamingEnded
          ) {
            this.loadingViewers = true
            const { data } = await apiAntmedia.get(
              `/${process.env.VUE_APP_ANTMEDIA_APP}/rest/v2/broadcasts/${item.broadcastId}/broadcast-statistics`
            )

            return {
              ...item,
              viewers: Math.round(
                Object.values(data)
                  .filter((value) => value != -1)
                  .reduce((prev, current) => prev + current, 0) / 7
              ),
            }
          } else return item
        }
        this.items = await Promise.all(this.items.map(fetchItemViewers))
      } catch (error) {
        console.log('Error when getting antmedia viewers :>> ', error)
      } finally {
        this.loadingViewers = false
      }
    },
    openApp(id) {
      window.open(`${process.env.VUE_APP_APP_URL}/#/home/match/${id}`, '_blank')
    },
    openAdmin(id) {
      const routeData = this.$router.resolve({
        name: 'match-edit',
        params: { id },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>
<style>
.item > .v-list__tile--avatar {
  height: auto;
}
</style>
